import Highcharts from 'highcharts';

export const figure14 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 300,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#ed7d31', '#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
  
      plotOptions: {
        series: {
          borderWidth: 0,
          marker: {
            symbol: 'circle',
            enabled: false,
            states: {
              hover: {
                enabled: true,
                radius: 5
              }
            }
          }
        }
      },
  
      exporting: {
        enabled: false
      },

      xAxis: [{
        categories: [ 
          "Albania 2005",
          "Armenia 2013",
          "Bangladesh 2010",
          "Bolivia (Estado Plurinacional de) 2008",
          "Bulgaria 2007",
          "Burkina Faso 2014",
          "Camboya 2009",
          "Camerún 2014",
          "Ecuador 2014",
          "Etiopía 2016",
          "Georgia 2015",
          "Ghana 2013",
          "Guatemala 2014",
          "India 2012",
          "Iraq 2012",
          "Kenya 2005",
          "Kirguistán 2013",
          "Malawi 2013",
          "Malawi 2017",
          "Malí 2017",
          "México 2014",
          "Mongolia 2014",
          "Mozambique 2009",
          "Nepal 2011",
          "Nicaragua 2014",
          "Níger 2014",
          "Nigeria 2019",
          "Pakistán 2014",
          "Panamá 2008",
          "Perú 2019",
          "Rwanda 2014",
          "Senegal 2011",
          "Serbia 2007",
          "Sierra Leona 2011",
          "República Unida de Tanzanía 2013",
          "República Unida de Tanzanía 2015",
          "Timor-Leste 2007",
          "Uganda 2016",
          "Viet Nam 2010",
       ],
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          }
        },
      }],
      yAxis: [{
        labels: {
          format: '{value}',
          formatter: function () {
              return this.value / 1000 + "M";
          },
          style: {
            fontWeight: 'normal',
            color: '#999999',
            fontSize: '12px'
          },
        },
        max: 16000,
        min: 0,
        tickInterval: 2000,
        gridLineWidth: 2,
        title: {
          text: null,
          style: {
            color: Highcharts.getOptions().colors[1]
          }
        }
      }],
      tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
          padding: 0
        }
      },
      legend: {
        enabled: false,
      },
  
      series: [{
        name: 'Pequeños productores',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data: [ 2974.50181, 1030.409459, 1093.099499, 1935.459064, 1472.051958, 714.8678262, 1387.297789, 2145.097778, 2159.833091, 687.7725629, 1982.509467, 1966.899338, 2725.506956, 2041.818928, 3649.172768, 933.7245784, 2384.781996, 624.5410768, 657.3306878, 1439.675004, 1554.093303, 4846.409903, 375.8091977, 1279.667633, 1609.585432, 318.8566565, 481.2593247, 3668.995251, 1381.398395, 1456.794428, 324.250268, 1080.176694, 3265.647863, 805.1887756, 494.3924848, 609.9230344, 1407.577771, 663.8233054, 2910.540559 ],
      },
      {
        name: 'Productores no pequeños',
        dataLabels: {
          enabled: false,
          style: {
            fontWeight: 'normal',
            textOutline: false,
            color: '#999999',
            fontSize: '12px'
          }
        },
        data:[ 6616.814883, 7582.186774, 3790.735454, 4701.912214, 6871.685768, 1764.141645, 2578.702108, 5227.776108, 4264.699173, 1686.201689, 6043.875857, 5425.203784, 7409.453186, 5873.733394, 11399.4075, 2869.081723, 7760.46615, 1451.028401, 8582.040986, 5113.753882, 12061.71386, 13908.09042, 2318.503399, 3706.114804, 7409.975778, 1024.943379, 1562.411552, 8008.797215, 4495.353322, 1975.711381, 873.8401549, 3339.673387, 9553.690965, 3474.575012, 0, 5310.054895, 3413.369162, 1882.877699, 8579.51957 ]
      }
    ]
}